import { globalRef } from '@amazon/vinyl-util'
import { openSystemModal } from '@/components/systemModal'
import { getString } from '@/signInDialog/i18n/bundle.generated'
import { startSignIn } from '@/metrics/startSignIn'
import { reportContentView } from '@/metrics/uiMetrics'

const AUTH_WALL_CONTENT_NAME = 'authWallModal'

const dialogState = globalRef(() => ({ open: false }))

/**
 * The in-place sign-in dialog a signed-out gesture opens, as GH's AuthWallModal: explanatory copy,
 * Sign In, and a close control that leaves the visitor where they were. One dialog at a time.
 */
export function openSignInModal(refMarker?: string): void {
    if (dialogState.value.open) return
    dialogState.value.open = true
    reportContentView({
        contentInfo: [{ contentName: AUTH_WALL_CONTENT_NAME }],
        ...(refMarker === undefined ? {} : { refMarker }),
    })
    openSystemModal({
        className: 'authWallModal',
        contentName: AUTH_WALL_CONTENT_NAME,
        ownContentView: true,
        title: getString('dmusic_auth_wall_modal_title'),
        body: getString('dmusic_auth_wall_modal_subtitle'),
        primary: {
            label: getString('dmusic_signin_button_text'),
            run: () => startSignIn(AUTH_WALL_CONTENT_NAME, refMarker),
        },
        onClose: () => {
            dialogState.value.open = false
        },
    })
}
